export default "__VITE_ASSET__DfW8KuaQ__"